import { createGame } from "./Game";

createGame();